module.exports = __webpack_public_path__ + "static/img/bottom.4d31be5.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/VascularSystem/Meeting790/images/bottom.png
// module id = 6L+8
// module chunks = 4